export type DetailPageNavigationState = {
  originHref?: string;
  /** Display text from the link column when it differs from detailsIdKey */
  detailsDiscriminatorDisplayValue?: string;
};

export function formatDetailPageLinkDisplayValue(
  value: unknown
): string | null {
  if (value == null) {
    return null;
  }
  if (Array.isArray(value)) {
    const parts = value.map(String).filter(Boolean);
    return parts.length > 0 ? parts.join(', ') : null;
  }
  const text = String(value);
  return text.length > 0 ? text : null;
}

export function getDetailsDiscriminatorDisplayValueFromLinkColumn(
  linkColumnKey: string | undefined,
  detailsIdKey: string,
  dataRows: Record<string, unknown>[]
): string | undefined {
  if (linkColumnKey == null || linkColumnKey === detailsIdKey) {
    return undefined;
  }
  const firstRow = dataRows[0];
  if (firstRow == null) {
    return undefined;
  }
  const display = formatDetailPageLinkDisplayValue(firstRow[linkColumnKey]);
  return display ?? undefined;
}

export function buildDetailPageNavigationState(
  originHref: string,
  detailPageConfig: { detailsIdKey: string },
  linkColumnKey: string | undefined,
  dataRows: Record<string, unknown>[]
): DetailPageNavigationState {
  const detailsDiscriminatorDisplayValue =
    getDetailsDiscriminatorDisplayValueFromLinkColumn(
      linkColumnKey,
      detailPageConfig.detailsIdKey,
      dataRows
    );

  return {
    originHref,
    ...(detailsDiscriminatorDisplayValue != null && {
      detailsDiscriminatorDisplayValue,
    }),
  };
}
